import "./Wholesale.css";

function Wholesale() {
  return (
    <div className="container py-5">
      <div className="row align-items-center">
        
        {/* Left: Pitch Section */}
        <div className="col-md-6 wholesale-pitch">
          <h2>Pse të bashkëpunoni me Probioma?</h2>
          <p>
            Te <strong>Probioma</strong>, ne besojmë se shëndeti dhe cilësia duhet të jenë
            në qendër të çdo biznesi ushqimor. Nëse jeni kafene, restorant apo distributor,
            jemi gati të sjellim freskinë e kombucha-s dhe superfood-eve tek klientët tuaj.
          </p>
          <ul>
            <li>🌱 <strong>Partner i Besueshëm</strong> – Produkte natyrale dhe cilësore.</li>
            <li>📦 <strong>Zgjidhje të Personalizuara</strong> – Nga porositë e vogla te distributorët e mëdhenj.</li>
            <li>🚚 <strong>Shpërndarje e Shpejtë</strong> – Transport i sigurt, falas në Tiranë.</li>
            <li>💡 <strong>Eksperiencë & Besim</strong> – Produkte unike për tregun shqiptar.</li>
            <li>🤝 <strong>Bashkëpunim Afatgjatë</strong> – Marrëdhënie mbi besim dhe zhvillim të ndërsjellë.</li>
          </ul>
        </div>

        {/* Right: Form Section */}
        <div className="col-md-6">
          <div className="wholesale-form-card p-4 shadow rounded">
            <h3 className="mb-3">Bëhuni Partner me Probioma</h3>
            <form>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Emri i Plotë*"
                required
              />
              <input
                type="email"
                className="form-control mb-3"
                placeholder="Email*"
                required
              />
              <input
                type="tel"
                className="form-control mb-3"
                placeholder="Telefoni"
              />
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Emri i Biznesit*"
                required
              />
              <select className="form-control mb-3" required>
                <option value="">Lloji i Biznesit</option>
                <option>Kafe</option>
                <option>Restorant</option>
                <option>Dyqan</option>
                <option>Distributor</option>
                <option>Tjetër</option>
              </select>
              <textarea
                className="form-control mb-3"
                rows="3"
                placeholder="Mesazhi"
              ></textarea>
              <button type="submit" className="btn btn-success w-100">
                Kërko Ofertë
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Wholesale;
